// This file does:
// ✅ Reads Shopify variant
// ✅ Reads Easify options
// ✅ Keeps everything in sync
// ✅ Outputs a clean config object

import { initLampScene, updateLampModel } from './lamp-3d-viewer.js?v=1.1.2';

let loaderElement;
let isInitialLoad = true;

const lampConfig = {
  fabric: null,
  lampBaseColor: null,
  trimColor: null
};

function get3dLampViewerContainer() {
  return document.getElementById("lamp-3d-viewer");
}

async function start3dTool() {
  const container = get3dLampViewerContainer();

  if (!container) {
    console.warn("Lamp container not found");
    return false;
  } 
  
  // Ensure loader is visible
  loaderElement = container.querySelector('.lamp-loader');
  loaderElement?.classList.remove('hidden');
  loaderElement?.classList.remove('error');

  try {
    await initLampScene();
  } catch (error) {
    showLoaderError("Failed to load 3D model");
    return;
  }

  // Wait for the trim color inputs to be available before setting up listeners and updating the configurator as Easify injects them asynchronously
  try {
    await waitForElement('input[name*="trim-color"]');
    await waitForElement('input[name*="lamp-base-color"]');
  } catch (error) {
    showLoaderError("Failed to load 3D model (error2)");
    return;
  }

  setupFabricListeners();
  setupEasifyListeners();

  updateConfigurator();
};

// Helper function to wait for an element to appear in the DOM
function waitForElement(selector, timeout = 30000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector); 
    if (element) {
      resolve(element);
      return;
    } 
    const observer = new MutationObserver(() => { 
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => { 
      observer.disconnect();
      reject(new Error(`Element "${selector}" not found within ${timeout}ms`));
    }, timeout);
  });
}

/* ---------- Loader Utilities ---------- */
function hideLoader() {
  if (loaderElement) {
    loaderElement.classList.add('hidden');
  }
}

function showLoaderError(message = "Failed to load 3D model") {
  if (loaderElement) {
    loaderElement.classList.add('error');
    loaderElement.classList.remove('hidden');
    const textElement = loaderElement.querySelector('.lamp-loader__text');
    if (textElement) {
      textElement.textContent = message;
    }
    console.error(message);
  }
}

function setupEasifyListeners() {
  document.addEventListener('click', (event) => {
    if (event.target.closest('.tpo_color-swatches-wrapper')) {
      updateConfigurator();
    }
  });
}

function setupFabricListeners() { 
  // Subscribe to the Shopify's event instead of using addEventListener
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    console.log('Variant changed:', event.detail);
    updateConfigurator()
  });
}


function updateConfigurator() {
  // Update fabric
  const checkedFabricInput = document.querySelector('input[name^="Fabric"]:checked, input[name^="Stof"]:checked');
  
  if (checkedFabricInput) {
    lampConfig.fabric = checkedFabricInput.value
  }

  // Update trim
  const checkedTrimInput = document.querySelector(
    'input.tpo_color-swatches-input[name*="trim-color"]:checked'
  );

  if (checkedTrimInput) {
    const colorSpanTrim = checkedTrimInput.closest("label")?.querySelector(".color-span-single");
    if (colorSpanTrim) {
      lampConfig.trimColor = colorSpanTrim.style.backgroundColor
    }
  }

  // Update base
  const checkedBaseInput = document.querySelector(
    'input.tpo_color-swatches-input[name*="lamp-base-color"]:checked'
  );

  if (checkedBaseInput) {
    const colorSpanBase = checkedBaseInput.closest("label")?.querySelector(".color-span-single");
    if (colorSpanBase) {
      lampConfig.lampBaseColor = colorSpanBase.style.backgroundColor;
    }
  }

  // Finally, update the 3D model with the new config
  updateLampModel(lampConfig);

  // Hide loader after initial configuration
  if (isInitialLoad) {
    hideLoader();
    isInitialLoad = false;
  }
}

start3dTool()